import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import AuctionCard from './AuctionCard';
import AuctionDetail from './AuctionDetail';
import AuctionListingModal from './AuctionListingModal';
import AuctionMyActivity from './AuctionMyActivity';
import AuctionStats from './AuctionStats';

// 경매장 메인 목록 — 필터/정렬/검색/페이지네이션
function AuctionMarketplace(props){
  var user=props.user;
  var[auctions,setAuctions]=useState([]);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');
  var[status,setStatus]=useState('active');
  var[sort,setSort]=useState('ending_soon');
  var[searchInput,setSearchInput]=useState('');
  var[activeSearch,setActiveSearch]=useState('');
  var[page,setPage]=useState(1);
  var[pagination,setPagination]=useState({total:0,page:1,limit:12,totalPages:0});
  var[viewMode,setViewMode]=useState('list');
  var[selectedAuctionId,setSelectedAuctionId]=useState(null);
  var[showListingModal,setShowListingModal]=useState(false);
  var[selectedMaker,setSelectedMaker]=useState('전체');

  // 제조사별 키워드 (차종명 부분매칭)
  var MAKERS=[
    {label:'현대',keywords:['아반떼','소나타','그랜저','투싼','싼타페','팰리세이드','아이오닉','스타리아','캐스퍼','코나','베뉴','넥쏘','포터','마이티','엑센트','i30','벨로스터']},
    {label:'기아',keywords:['모닝','레이','K3','K5','K7','K8','K9','셀토스','스포티지','쏘렌토','카니발','니로','EV6','EV9','봉고','스팅어','텔루라이드','포르테','프라이드','쏘울']},
    {label:'제네시스',keywords:['G70','G80','G90','GV60','GV70','GV80']},
    {label:'쉐보레',keywords:['스파크','말리부','트래버스','트레일블레이저','이쿼녹스','볼트','콜로라도','타호','크루즈','임팔라','카마로','올란도','스파크']},
    {label:'르노',keywords:['QM3','QM5','QM6','SM3','SM5','SM6','SM7','XM3','마스터','클리오','아르카나','그랑 콜레오스']},
    {label:'KG모빌리티',keywords:['티볼리','코란도','렉스턴','토레스','액티언','체어맨','무쏘','카이런']},
    {label:'BMW',keywords:['BMW','3시리즈','5시리즈','7시리즈','X1','X2','X3','X4','X5','X6','X7','Z4','i3','i4','i7','i8','M3','M4','M5','320','328','520','528','535','730']},
    {label:'벤츠',keywords:['벤츠','Mercedes','C200','C220','C300','E200','E220','E250','E300','E350','E400','S320','S350','S400','S500','S600','GLA','GLB','GLC','GLE','GLS','CLA','CLS','C클래스','E클래스','S클래스']},
    {label:'아우디',keywords:['아우디','Audi','A3','A4','A5','A6','A7','A8','Q2','Q3','Q5','Q7','Q8','e-tron','S3','S4','RS']}
  ];

  // 차종명 → 제조사 매칭
  function matchMaker(model,makerLabel){
    if(!model)return false;
    var lower=String(model).toLowerCase();
    if(makerLabel==='기타'){
      // 모든 MAKERS에 매칭되지 않으면 기타
      for(var i=0;i<MAKERS.length;i++){
        var m=MAKERS[i];
        for(var j=0;j<m.keywords.length;j++){
          if(lower.indexOf(String(m.keywords[j]).toLowerCase())>=0)return false;
        }
      }
      return true;
    }
    var maker=MAKERS.find(function(m){return m.label===makerLabel});
    if(!maker)return false;
    for(var k=0;k<maker.keywords.length;k++){
      if(lower.indexOf(String(maker.keywords[k]).toLowerCase())>=0)return true;
    }
    return false;
  }

  var STATUS_TABS=[
    {key:'active',label:'입찰중'},
    {key:'pending_selection',label:'선택대기'},
    {key:'sold',label:'낙찰완료'},
    {key:'all',label:'전체'},
    {key:'my',label:'내 활동'},
    {key:'stats',label:'📊 통계'}
  ];

  var SORT_OPTIONS=[
    {key:'ending_soon',label:'마감임박순'},
    {key:'newest',label:'최신순'},
    {key:'price_high',label:'가격 높은순'},
    {key:'price_low',label:'가격 낮은순'},
    {key:'bids',label:'입찰 많은순'}
  ];

  var loadAuctions=function(pageArg,append){
    if(status==='my'||status==='stats'){setLoading(false);return}
    setLoading(true);
    setError('');
    var params=new URLSearchParams();
    params.append('status',status);
    params.append('sort',sort);
    params.append('page',String(pageArg||1));
    params.append('limit','50');
    if(activeSearch)params.append('q',activeSearch);
    authFetch(API+'/auctions?'+params.toString())
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          var list=d.data.auctions||[];
          if(append){
            setAuctions(function(prev){return prev.concat(list)});
          }else{
            setAuctions(list);
          }
          setPagination(d.data.pagination||{total:0,page:1,limit:12,totalPages:0});
        }else{
          setError((d&&d.error)||'조회 실패');
          if(!append)setAuctions([]);
        }
      })
      .catch(function(){setError('서버 연결 실패');if(!append)setAuctions([])})
      .then(function(){setLoading(false)});
  };

  useEffect(function(){
    setPage(1);
    loadAuctions(1,false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[status,sort,activeSearch]);

  // WebSocket 실시간 갱신 — 디바운스 500ms
  var fetchTimerRef=useRef(null);
  useEffect(function(){
    var s=getSocket();
    if(!s)return;
    var refresh=function(){
      if(fetchTimerRef.current)clearTimeout(fetchTimerRef.current);
      fetchTimerRef.current=setTimeout(function(){setPage(1);loadAuctions(1,false)},500);
    };
    var events=['auction:new-listing','auction:bid-received','auction:winner-selected','auction:pending-selection','auction:expired','auction:cancelled','auction:rejected-all','auction:failed','auction:purged'];
    events.forEach(function(ev){s.on(ev,refresh)});
    return function(){
      events.forEach(function(ev){s.off(ev,refresh)});
      if(fetchTimerRef.current)clearTimeout(fetchTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[status,sort,activeSearch]);

  var handleSearchSubmit=function(){
    setActiveSearch(searchInput.trim());
  };

  var handleSearchClear=function(){
    setSearchInput('');
    setActiveSearch('');
  };

  var handleLoadMore=function(){
    var next=page+1;
    setPage(next);
    loadAuctions(next,true);
  };

  var handleCardClick=function(auction){
    setSelectedAuctionId(auction.id);
    setViewMode('detail');
    try{window.scrollTo(0,0)}catch(e){}
    try{window.history.pushState({view:'auction-detail',id:auction.id},'')}catch(e){}
  };

  var handleBackToList=function(){
    // 브라우저 history.back으로 popstate 리스너가 state 초기화
    try{window.history.back()}catch(e){setViewMode('list');setSelectedAuctionId(null)}
  };

  // 브라우저 뒤로가기 감지 — detail 상태 아니면 목록 복귀
  useEffect(function(){
    var handlePopState=function(e){
      if(!e.state||e.state.view!=='auction-detail'){
        setViewMode('list');
        setSelectedAuctionId(null);
      }
    };
    window.addEventListener('popstate',handlePopState);
    return function(){window.removeEventListener('popstate',handlePopState)};
  },[]);

  var handleListingClick=function(){
    setShowListingModal(true);
  };

  var handleListingSuccess=function(newAuction){
    setShowListingModal(false);
    // 현재 필터/정렬/페이지 유지한 채 첫 페이지부터 리페치
    setPage(1);
    loadAuctions(1,false);
    // 방금 생성한 경매로 바로 이동 (선택적 UX)
    if(newAuction&&newAuction.id){
      setSelectedAuctionId(newAuction.id);
      setViewMode('detail');
      try{window.scrollTo(0,0)}catch(e){}
      try{window.history.pushState({view:'auction-detail',id:newAuction.id},'')}catch(e){}
    }
  };

  var handleFavoriteChange=function(id,favData){
    setAuctions(function(prev){
      return prev.map(function(a){
        if(a.id!==id)return a;
        var next=Object.assign({},a);
        next.liveStats=Object.assign({},a.liveStats||{},{favoriteCount:favData.favoriteCount});
        next.myStatus=Object.assign({},a.myStatus||{},{isFavorite:favData.isFavorite});
        return next;
      });
    });
  };

  var isMyTab=status==='my';
  var isStatsTab=status==='stats';
  var hasMore=pagination.totalPages>page;

  // 제조사 필터 적용 + 동적 가능 제조사 목록
  var availableMakers=[];
  if(auctions.length>0){
    // 현재 로드된 경매에서 실제 존재하는 제조사만 표시
    MAKERS.forEach(function(m){
      var hit=auctions.some(function(a){return matchMaker((a.car&&a.car.model)||'',m.label)});
      if(hit)availableMakers.push(m.label);
    });
    var hasEtc=auctions.some(function(a){return matchMaker((a.car&&a.car.model)||'','기타')});
    if(hasEtc)availableMakers.push('기타');
  }
  // 선택된 제조사가 현재 가용 목록에 없으면 "전체"로 리셋 (자동 방어)
  if(selectedMaker!=='전체'&&availableMakers.indexOf(selectedMaker)<0&&auctions.length>0){
    setTimeout(function(){setSelectedMaker('전체')},0);
  }

  var filteredAuctions=selectedMaker==='전체'?auctions:auctions.filter(function(a){
    return matchMaker((a.car&&a.car.model)||'',selectedMaker);
  });

  var showEmpty=!loading&&!error&&filteredAuctions.length===0&&!isMyTab&&!isStatsTab;

  // 상세 모드 — 내부 state 전환
  if(viewMode==='detail'&&selectedAuctionId){
    return <AuctionDetail auctionId={selectedAuctionId} onBack={handleBackToList}/>;
  }

  return (
    <div style={{padding:'20px 24px',maxWidth:1400,margin:'0 auto',minHeight:'100%'}}>
      {/* 헤더 */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:18,flexWrap:'wrap',gap:12}}>
        <div>
          <h1 style={{fontSize:24,fontWeight:800,color:'#1B3A5C',margin:0,display:'flex',alignItems:'center',gap:8}}>
            <span>🏛️</span><span>오토덱스 입찰</span>
            <span style={{fontSize:10,padding:'2px 8px',background:'#fef3c7',color:'#92400e',borderRadius:4,fontWeight:700,letterSpacing:0.3,marginLeft:4}}>BETA</span>
          </h1>
          {!isMyTab&&!isStatsTab&&(
            <div style={{fontSize:12,color:'#64748b',marginTop:4}}>
              {status==='active'?'진행 중 ':status==='sold'?'낙찰 완료 ':status==='pending_selection'?'선택 대기 ':'전체 '}
              <strong style={{color:'#1B3A5C'}}>{selectedMaker==='전체'?pagination.total:filteredAuctions.length}</strong>건
              {selectedMaker!=='전체'&&<span style={{marginLeft:4,color:'#94a3b8'}}>({selectedMaker})</span>}
            </div>
          )}
        </div>
        <button onClick={handleListingClick}
          style={{padding:'10px 22px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 2px 8px rgba(27,58,92,0.25)'}}>
          + 출품하기
        </button>
      </div>

      {/* 상태 탭 */}
      <div style={{display:'flex',gap:2,marginBottom:14,borderBottom:'1px solid #e5e7eb',overflowX:'auto'}}>
        {STATUS_TABS.map(function(tab){
          var active=status===tab.key;
          return (
            <button key={tab.key} onClick={function(){setStatus(tab.key)}}
              style={{padding:'10px 18px',background:'none',border:'none',borderBottom:active?'2px solid #1B3A5C':'2px solid transparent',color:active?'#1B3A5C':'#64748b',fontSize:13,fontWeight:active?700:500,cursor:'pointer',whiteSpace:'nowrap',marginBottom:-1,transition:'color 0.15s'}}>
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* 제조사 필터 (동적 가시성 — 실제 존재하는 제조사만) */}
      {!isMyTab&&!isStatsTab&&availableMakers.length>0&&(
        <div style={{display:'flex',gap:6,marginBottom:14,overflowX:'auto',paddingBottom:2}}>
          <button onClick={function(){setSelectedMaker('전체')}}
            style={{flexShrink:0,padding:'8px 16px',borderRadius:9999,border:'1px solid '+(selectedMaker==='전체'?'#1B3A5C':'#cbd5e1'),background:selectedMaker==='전체'?'#1B3A5C':'#fff',color:selectedMaker==='전체'?'#fff':'#475569',fontSize:12,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap',transition:'all 0.15s'}}>
            전체
          </button>
          {availableMakers.map(function(m){
            var active=selectedMaker===m;
            return (
              <button key={m} onClick={function(){setSelectedMaker(m)}}
                style={{flexShrink:0,padding:'8px 16px',borderRadius:9999,border:'1px solid '+(active?'#1B3A5C':'#cbd5e1'),background:active?'#1B3A5C':'#fff',color:active?'#fff':'#475569',fontSize:12,fontWeight:active?800:600,cursor:'pointer',whiteSpace:'nowrap',transition:'all 0.15s'}}>
                {m}
              </button>
            );
          })}
        </div>
      )}

      {/* 정렬 + 검색 */}
      {!isMyTab&&!isStatsTab&&(
        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:18,flexWrap:'wrap'}}>
          <select value={sort} onChange={function(e){setSort(e.target.value)}}
            style={{padding:'8px 12px',borderRadius:6,border:'1px solid #cbd5e1',fontSize:12,background:'#fff',cursor:'pointer',fontWeight:600,color:'#475569'}}>
            {SORT_OPTIONS.map(function(o){return <option key={o.key} value={o.key}>{o.label}</option>})}
          </select>
          <div style={{flex:1,minWidth:200,maxWidth:440,display:'flex',alignItems:'center',gap:6,padding:'6px 10px',background:'#fff',border:'1px solid #cbd5e1',borderRadius:6}}>
            <span style={{color:'#94a3b8',fontSize:13}}>🔍</span>
            <input value={searchInput} onChange={function(e){setSearchInput(e.target.value)}}
              onKeyDown={function(e){if(e.key==='Enter')handleSearchSubmit()}}
              placeholder="차종 / 차량번호 검색..."
              style={{flex:1,border:'none',outline:'none',fontSize:12,padding:'4px 0',background:'transparent'}}/>
            {activeSearch&&(
              <button onClick={handleSearchClear}
                style={{background:'none',border:'none',color:'#94a3b8',cursor:'pointer',fontSize:14,padding:0}}>✕</button>
            )}
          </div>
          <button onClick={handleSearchSubmit}
            style={{padding:'8px 16px',background:'#f1f5f9',border:'1px solid #cbd5e1',borderRadius:6,fontSize:12,fontWeight:600,color:'#475569',cursor:'pointer'}}>
            검색
          </button>
        </div>
      )}

      {/* 내 활동 탭 */}
      {isMyTab&&(
        <AuctionMyActivity onViewAuction={function(id){handleCardClick({id:id})}}/>
      )}

      {/* 통계 탭 */}
      {isStatsTab&&(
        <AuctionStats
          onViewAuction={function(id){handleCardClick({id:id})}}
          onGotoMarketplace={function(filter){setStatus(filter);setSelectedMaker('전체')}}/>
      )}

      {/* 에러 */}
      {error&&!loading&&!isMyTab&&!isStatsTab&&(
        <div style={{padding:'12px 16px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,color:'#dc2626',fontSize:13,marginBottom:14}}>
          ⚠ {error}
        </div>
      )}

      {/* 로딩 스켈레톤 */}
      {loading&&auctions.length===0&&!isMyTab&&!isStatsTab&&(
        <div className="car-grid">
          {[0,1,2,3,4,5].map(function(i){
            return (
              <div key={i} style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'hidden'}}>
                <div style={{width:'100%',paddingTop:'62%',background:'linear-gradient(90deg,#f1f5f9,#e2e8f0,#f1f5f9)'}}/>
                <div style={{padding:14}}>
                  <div style={{height:14,width:'70%',background:'#f1f5f9',borderRadius:4,marginBottom:8}}/>
                  <div style={{height:10,width:'40%',background:'#f1f5f9',borderRadius:4,marginBottom:12}}/>
                  <div style={{height:22,width:'55%',background:'#f1f5f9',borderRadius:4,marginBottom:10}}/>
                  <div style={{height:10,width:'80%',background:'#f1f5f9',borderRadius:4}}/>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* 빈 상태 */}
      {showEmpty&&(
        <div style={{padding:'80px 20px',textAlign:'center',color:'#94a3b8',background:'#fff',borderRadius:12,border:'1px solid #e5e7eb'}}>
          <div style={{fontSize:64,marginBottom:16,opacity:0.4}}>🚗</div>
          <div style={{fontSize:16,fontWeight:700,color:'#64748b'}}>
            {activeSearch?'검색 결과가 없습니다':selectedMaker!=='전체'?selectedMaker+' 차량이 없습니다':'아직 출품된 차량이 없습니다'}
          </div>
          <div style={{fontSize:13,marginTop:6}}>
            {activeSearch?'다른 키워드로 검색해보세요':selectedMaker!=='전체'?'다른 제조사를 선택해보세요':'첫 번째 경매를 시작해보세요!'}
          </div>
          {!activeSearch&&selectedMaker==='전체'&&(
            <button onClick={handleListingClick}
              style={{marginTop:22,padding:'10px 26px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>
              + 출품하기
            </button>
          )}
          {selectedMaker!=='전체'&&(
            <button onClick={function(){setSelectedMaker('전체')}}
              style={{marginTop:22,padding:'10px 26px',background:'#fff',border:'1px solid #cbd5e1',borderRadius:8,fontSize:13,fontWeight:700,color:'#475569',cursor:'pointer'}}>
              전체 제조사 보기
            </button>
          )}
        </div>
      )}

      {/* 카드 그리드 */}
      {!isMyTab&&!isStatsTab&&filteredAuctions.length>0&&(
        <div className="car-grid">
          {filteredAuctions.map(function(a){
            return <AuctionCard key={a.id} auction={a} onClick={handleCardClick} onFavoriteChange={handleFavoriteChange}/>
          })}
        </div>
      )}

      {/* 더 보기 */}
      {!isMyTab&&!isStatsTab&&hasMore&&!loading&&(
        <div style={{textAlign:'center',marginTop:26}}>
          <button onClick={handleLoadMore}
            style={{padding:'12px 32px',background:'#fff',border:'1px solid #cbd5e1',borderRadius:8,fontSize:13,fontWeight:600,color:'#475569',cursor:'pointer'}}>
            더 보기 ({pagination.total-auctions.length}건 남음)
          </button>
        </div>
      )}

      {/* 추가 로딩 (append 중) */}
      {loading&&auctions.length>0&&(
        <div style={{textAlign:'center',marginTop:16,fontSize:12,color:'#94a3b8'}}>불러오는 중...</div>
      )}

      {/* 출품 모달 */}
      {showListingModal&&(
        <AuctionListingModal
          user={user}
          onClose={function(){setShowListingModal(false)}}
          onSuccess={handleListingSuccess}/>
      )}
    </div>
  );
}

export default AuctionMarketplace;
